import React, { useEffect, useState } from 'react';
import RegistrationStep1 from './widgets/steps/LoginStep1';
import RegistrationStep2 from './widgets/steps/LoginStep2';
import { RootState } from '../../store/store';
import { useLocation } from 'react-router-dom';
import { useAppDispatch } from '../../store/store';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { login, register } from '../../shared/api/authApi';
import StepHeader from '../auth-page/widgets/step-header/StepHeader';
import s from './LoginPage.module.css';
import IconLogo from '../../shared/ui/icons/IconLogo';
import Testimonials from './widgets/Testimonials';

export interface FormData {
    email: string;
}

const RegistrationPage = () => {
    const [step, setStep] = useState(1);
    const [code, setCode] = useState<string>('');
    const dispatch = useAppDispatch();
    const navigate = useNavigate();
    const location = useLocation();
    const { isLoading, errors, user, isAuthenticated } = useSelector(
        (state: RootState) => state.auth,
    );

    const [formData, setFormData] = useState<FormData>({
        email: '',
    });
    const [formErrors, setFormErrors] = useState<Partial<FormData>>({});

    useEffect(() => {
        if (errors) {
            setFormErrors(errors[0]);
        }
    }, [errors]);

    const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        console.log('handleInputChange', e.target);
        const { id, value } = e.target;
        setFormData((prev) => ({
            ...prev,
            [id]: value,
        }));
        if (formErrors[id as keyof FormData]) {
            setFormErrors((prev) => ({
                ...prev,
                [id]: undefined,
            }));
        }
    };

    const handleSwitch = (newTab: string) => {
        setFormData({
            email: '',
        });
        setFormErrors({});
    };

    const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();

        if (step === 2) {
            setStep(3);
        }

        const errors: Partial<FormData> = {};

        if (!formData.email.trim()) {
            errors.email = 'This field is required.';
        } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
            errors.email = 'Email is invalid';
        }

        setFormErrors(errors);

        console.log('formData', formData);

        if (Object.keys(errors).length > 0) {
            return;
        }
        try {
            const response = await dispatch(login({ email: formData.email })).unwrap();
            console.log('response', response);

            const searchParams = new URLSearchParams(location.search);
            const operationType = response?.data?.type || 'login';

            searchParams.set('type', operationType);

            if (operationType === 'registration') {
                const hasParam = searchParams.has('onboard_status');
                if (!hasParam) {
                    searchParams.set('onboard_status', '0');
                }
            }

            navigate(`${location.pathname}?${searchParams.toString()}`, { replace: true });
            setStep(2);
        } catch (error: any) {
            if (Array.isArray(error)) {
                const first = error[0];
                setFormErrors({ email: first?.detail || first?.title || 'Login failed' });
            } else if (typeof error === 'string') {
                setFormErrors({ email: error });
            }
        }
    };

    useEffect(() => {
        const searchParams = new URLSearchParams(location.search);
        const urlToken = searchParams.get('auth_token');

        if (urlToken && isAuthenticated && user?.email_verified_at) {
            handleSwitch('signup');
            setStep(3);
        } else if (user && !user?.email_verified_at && isAuthenticated) {
            handleSwitch('signup');
            setStep(2);
        } else if (urlToken) {
            navigate('/dashboard');
        }
    }, [user, isAuthenticated]);

    const totalSteps = 3;
    return (
        <div className={s.container}>
            <StepHeader
                step={step}
                setStep={setStep}
                totalSteps={totalSteps}
                handleSwitch={handleSwitch}
            />
            <div className={s.form_container}>
                <IconLogo width={50} height={50} />
                <h1 className={s.title} style={{ marginTop: '20px' }}>
                    Welcome to SimpleeCreate
                </h1>
                <p className={s.subtitle}>You, but amplified. Every day.</p>

                {step === 1 && (
                    <RegistrationStep1
                        handleInputChange={handleInputChange}
                        formErrors={formErrors as FormData}
                        isLoading={isLoading}
                        formData={formData}
                        handleSubmit={handleSubmit}
                    />
                )}
                {step === 2 && (
                    <RegistrationStep2
                        setStep={setStep}
                        code={code}
                        setCode={setCode}
                        email={formData?.email}
                    />
                )}
            </div>
        </div>
    );
};

export default RegistrationPage;
